import React from 'react';
import styled, { css } from 'styled-components';
import { BlockLayoutComponent } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { useEntity, useLang } from '@shapeable/ui';
import { useSite } from '../../hooks/use-site';
import { MetricValue } from '../elements/metric-value';
import { MetricLayout } from '../entities/metric-layout';

// -------- Child Component Props -------->

type ContainerProps = {

}

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
  
  `,
});

const ValueStyles = breakpoints({
  base: css`
    margin-top: ${theme.UNIT(2)};
    align-self: center;
  `,
});


// -------- Components -------->

const My = {
  Container: styled(MetricLayout)<ContainerProps>`${ContainerStyles}`,
    Value: styled(MetricValue)`${ValueStyles}`,
};

export const BlockLayoutTotalVisitorDays: BlockLayoutComponent = (props) => {
  const { className, children } = props;
  const entity = useEntity(props.entity);
  const { metrics } = useSite();
  
  const t = useLang();
  
  const { totalVisitorDays } = metrics;

  return (
    <My.Container ratio={2} showContent entity={entity} className={className}>
      <My.Value comingSoon value={totalVisitorDays} />
    </My.Container>
  )
};